import { Checkbox, Grid, VStack } from '@chakra-ui/react'
import { CheckboxGroupFormControl } from 'BrokerTsLib/src/components'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { Risk, RiskVariant } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

import { useGetRiskVariants } from '@/hooks'
import Car from '@/images/car.svg?react'
import CarCrash from '@/images/carCrash.svg?react'
import CarPercent from '@/images/carPercent.svg?react'

function VariantSelectionCheckbox({
  isDisabled = false,
}: {
  isDisabled?: boolean
}) {
  const { setValue, watch, control } = useFormContext<InsuranceParamsDto>()

  const { data: dataPov } = useGetRiskVariants(Risk.POV)
  const { data: dataHav } = useGetRiskVariants(Risk.HAV)
  const { data: dataSpol } = useGetRiskVariants(Risk.SPOL)

  const vehiclePrice = watch('vehicle.price')
  useEffect(() => {
    if (!vehiclePrice) setValue('baseParams.hav', [RiskVariant.WithoutHAV])
  }, [vehiclePrice])

  const hav = watch('baseParams.hav')

  const havSelected =
    (hav?.filter((x) => x != RiskVariant.WithoutHAV).length ?? 0) !== 0

  return (
    <Grid
      sx={{
        w: '100%',
        gridTemplateColumns: {
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 8,
        alignItems: 'start',
        justifyContent: 'space-between',
      }}
    >
      <CheckboxGroupFormControl
        name="baseParams.pov"
        label="Povinné ručení (mil. Kč)"
        labelProps={{ icon: <Car /> }}
        gap={8}
        valueAsNumber
        isDisabled={isDisabled}
        control={control}
      >
        <VStack sx={{ ml: 2 }} align="start" gap={3}>
          {dataPov?.data.map((x) => (
            <Checkbox key={x.id} value={x.id}>
              {x.name}
            </Checkbox>
          ))}
        </VStack>
      </CheckboxGroupFormControl>

      <CheckboxGroupFormControl
        name="baseParams.hav"
        label="Havarijní pojištění"
        labelProps={{
          icon: <CarCrash />,
          hint:
            !vehiclePrice &&
            'Pro výběr havarijního pojištění je potřeba vyplnit PČ vozidla.',
          hintType: 'warning',
        }}
        gap={8}
        valueAsNumber
        isDisabled={isDisabled || !vehiclePrice}
        control={control}
      >
        <VStack sx={{ ml: 2 }} align="start" gap={3}>
          {dataHav?.data
            .filter((x) => x.id != RiskVariant.Package)
            .map((x) => (
              <Checkbox key={x.id} value={x.id}>
                {x.name}
              </Checkbox>
            ))}
        </VStack>
      </CheckboxGroupFormControl>

      <CheckboxGroupFormControl
        name="baseParams.spol"
        label="Spoluúčast"
        labelProps={{ icon: <CarPercent /> }}
        gap={8}
        valueAsNumber
        isDisabled={isDisabled || !havSelected}
        control={control}
      >
        <VStack sx={{ ml: 2 }} align="start" gap={3}>
          {dataSpol?.data.map((x) => (
            <Checkbox key={x.id} value={x.id}>
              {x.name.replace('Spoluúčast', '')}
            </Checkbox>
          ))}
        </VStack>
      </CheckboxGroupFormControl>
    </Grid>
  )
}

export default VariantSelectionCheckbox
